module.exports = __webpack_public_path__ + "static/media/theme-icons.e64ff61f.svg";